/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_PublishedInputs */

const en_directory_submit_workspace_aside_published = /** @type {(inputs: Directory_Submit_Workspace_Aside_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published listing`)
};

const zh_directory_submit_workspace_aside_published = /** @type {(inputs: Directory_Submit_Workspace_Aside_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布条目`)
};

/**
* | output |
* | --- |
* | "Published listing" |
*
* @param {Directory_Submit_Workspace_Aside_PublishedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_published = /** @type {((inputs?: Directory_Submit_Workspace_Aside_PublishedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_PublishedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_published(inputs)
	return zh_directory_submit_workspace_aside_published(inputs)
});
export { directory_submit_workspace_aside_published as "directory.submit.workspace.aside.published" }